/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForPolicyAws extends models.GovernanceConfigurationBaseForPolicy {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForPolicyAws");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForPolicyAws.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForPolicyAws>): GovernanceConfigurationForPolicyAws {
        let obj = Object.assign(new GovernanceConfigurationForPolicyAws(), model);
        GovernanceConfigurationForPolicyAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForPolicyAws>): GovernanceConfigurationForPolicyAws {
        if (!model) return null;
        return GovernanceConfigurationForPolicyAws.newInstance(<GovernanceConfigurationForPolicyAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForPolicyAws) {
        if (!obj) return;

        models.GovernanceConfigurationForPolicyAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForPolicyAws): boolean {
        if (models.GovernanceConfigurationBaseForPolicy.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForPolicyAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
